<template>
  <span>
    <li v-if="info.link" :class="info.ext" :data-hash="info.hash">
      <a :href="info.link" target="_blank">{{ info.title }}</a>
      <a v-if="info.desc_link" class="desc-program" target="_blank" :href="info.desc_link">{{ info.desc_title }}</a>
    </li>
    <li v-if="info.guid" :class="this.get_url_extension(info.url)" :data-hash="info.guid" style="position: relative">
      <a :href="info.url" target="_blank">{{ info.full_name }}</a>
      <span v-if="info.sign.approved">
        <sig-info :info="info.sign"></sig-info>
      </span>
    </li>
    <li v-if="info.guid === ''" :class="this.get_url_extension(info.url)" style="position: relative">
      <a :href="info.url" target="_blank">{{ info.full_name }}</a>
    </li>
    <li v-if="typeof info.related_file != 'undefined'" :class="this.get_url_extension(info.related_file.url)" :data-hash="info.related_file.guid" style="position: relative; margin-left: 40px;">
      <a :href="info.related_file.url" target="_blank">{{ info.related_file.full_name }}</a>
      <span v-if="info.related_file.sign.approved">
        <sig-info v-if="info.parent_guid !== ''" :info="info.related_file.sign"></sig-info>
      </span>
    </li>
  </span>
</template>

<script>

import SigInfo from './SigInfo'

export default {
  name: "FileV2",
  components: {
    "sig-info":SigInfo
  },
  props: ["info"],
  getData() {
    return {}
  },
  methods: {
    get_url_extension: function (url) {
      if(url.match("(stage-doc-upload.mos.ru)")){
        return 'file'
      }
      return url.split('.').slice(-1)
    },
  }
}
</script>

<style>
  .file{
    background-image: url('../assets/file.png');
  }
</style>
